export default {
	watch: {
		paginacaoInterna: {
			handler(novoValor) {
				this.$emit('paginar', novoValor)
			},
			deep: true,
		},
	},
	props: {
		paginacao: {
			type: Object,
			required: false,
		},
		totalItens: {
			type: Number,
			required: true,
		},
		totalPaginas: {
			type: Number,
			required: true,
		},
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
	},
}
